import { render, staticRenderFns } from "./MentorGrid.vue?vue&type=template&id=6c1af184&"
import script from "./MentorGrid.vue?vue&type=script&lang=js&"
export * from "./MentorGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports